import { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { UseAuth } from "../../../utils/UseAuth";
import Breadcrumbs from "../../../components/auth/breadcrumbs/Breadcrumbs";
import FormikAudioInput from "../../../components/auth/form/FormikAudioInput";
import { INVITATION } from "../../../api/Invitation";
import { CONSTANT } from "../../../constant/Constant";

export default function InvitationEdit() {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { checkAccessTokenValidity } = UseAuth();

  const [reRunData, setReRunData] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const theme = [
    {
      id: 1,
      title: "Theme 1",
    },
    {
      id: 2,
      title: "Theme 2",
    },
  ];
  const [imageList, setImageList] = useState([]);
  const [imageView, setimageView] = useState("");
  const [flowerView, setFlowerView] = useState("");
  const [viewWish, setViewWish] = useState(false);
  const [change, setChange] = useState(false);
  const [data, setData] = useState({
    datetime: "",
    bride: "",
    groom: "",
    eventLoc: "",
    eventLocLink: "",
    eventName: "",
    receptionLoc: "",
    receptionTime: "",
    receptionLocLink: "",
    receptionName: "",
    youtubeLink: "",
    bgColor: "",
    music: null,
    flower: null,
    description: "",
    thumbnail: null,
    theme: theme[0].title,
    images: [],
    wishes: [],
  });
  const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
  const validationSchema = Yup.object().shape({
    datetime: Yup.string().required("* Must add the date and time"),
    bride: Yup.string().required("* Required"),
    groom: Yup.string().required("* Required"),
    eventLoc: Yup.string().required("* Required"),
    eventLocLink: Yup.string().required("* Required"),
    bgColor: Yup.string().required("* Required"),
    description: Yup.string().required("* Required"),
    music: Yup.mixed()
      .required("An audio file is required")
      .test("fileType", "Only MP3 files are allowed", (value) => {
        if (!value || typeof value === "string") return true; // ✅ skip check if it's a string
        return value.type === "audio/mpeg";
      })
      .test("fileSize", "File too large (max 10MB)", (value) => {
        if (!value || typeof value === "string") return true; // ✅ skip check if it's a string
        return value.size <= 10 * 1024 * 1024;
      }),
    images: Yup.array()
      .required("Please upload 6 images")
      .min(6, "Exactly 6 images required")
      .max(6, "Exactly 6 images required")
      .test(
        "is-image-type",
        "Only JPG, JPEG, PNG files are allowed",
        (files) => {
          if (!files || files.length !== 6) return false;

          return files.every((file) => {
            // Accept if it's a URL string (already uploaded image)
            if (typeof file === "string") return true;

            // Accept if it's a valid File object of correct type
            return file && SUPPORTED_FORMATS.includes(file.type);
          });
        }
      ),

    thumbnail: Yup.mixed()
      .test("required", "Thumbnail is required", (value) => {
        return !!value; // must be truthy
      })
      .test("fileType", "Unsupported file format", (value) => {
        if (!value || typeof value === "string") return true; // allow already uploaded image
        return ["image/jpeg", "image/png", "image/jpg"].includes(value.type);
      })
      .test("fileSize", "File size is too large", (value) => {
        if (!value || typeof value === "string") return true; // skip size check for URL
        return value.size <= 5 * 1024 * 1024; // 5MB limit
      }),

    flower: Yup.mixed()
      .required("Flower image is required")
      .test("fileType", "Unsupported file format", (value) => {
        // Allow URL strings (already uploaded)
        if (typeof value === "string") return true;

        // Allow only valid image MIME types
        return (
          value && ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
        );
      })
      .test("fileSize", "File size is too large", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return value.size <= 5 * 1024 * 1024; // 5MB limit
      }),
  });
  const handleUpdateWish = async (wishArray) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("wishes", JSON.stringify(wishArray));
    formData.append("datetime", data.datetime);
    formData.append("bridesName", data.bride);
    formData.append("groomsName", data.groom);
    try {
      setLoading(false);
      const res = await INVITATION.UPDATE(formData, id);
      if (res.status === 200) {
        setChange(!change);
        toast.success("Wishes updated succesfully");
      } else {
        toast.error("Failed to Update Invitation");
        throw new Error("failed to create an topic");
      }
    } catch (error) {
      setLoading(false);
      // console.log("error", error);
    }
  };

  const approveWish = async (i) => {
    const updatedArray = [];
    data.wishes.map((itm, index) => {
      if (i === index) {
        const data = {
          wish: itm.wish,
          from: itm.from,
          isApproved: true,
        };
        updatedArray.push(data);
      } else {
        updatedArray.push(itm);
      }
      return updatedArray;
    });
    await handleUpdateWish(updatedArray);
  };
  const hideWish = async (i) => {
    const updatedArray = [];
    data.wishes.map((itm, index) => {
      if (i === index) {
        const data = {
          wish: itm.wish,
          from: itm.from,
          isApproved: false,
        };
        updatedArray.push(data);
      } else {
        updatedArray.push(itm);
      }
      return updatedArray;
    });
    await handleUpdateWish(updatedArray);
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    const location1 = {
      title: values.eventLoc,
      link: values.eventLocLink,
      name: values.eventName,
    };
    const location2 = {
      title: values.receptionLoc,
      link: values.receptionLocLink,
      time: values.receptionTime,
      name: values.receptionName,
    };
    const addLoc2 = values.receptionLoc !== "" ? true : false;
    const addYouTube = values.youtubeLink !== "" ? true : false;
    const addMusic = values.music !== null ? true : false;
    const formData = new FormData();
    formData.append("datetime", values.datetime);
    formData.append("bridesName", values.bride);
    formData.append("groomsName", values.groom);

    formData.append("location1", JSON.stringify(location1));
    formData.append("addLoc2", addLoc2);
    formData.append("location2", JSON.stringify(location2));
    formData.append("addYouTube", addYouTube);
    formData.append("youTubeLink", values.youtubeLink);
    formData.append("addMusic", addMusic);
    formData.append("music", values.music);
    formData.append("flower", values.flower);
    formData.append("description", values.description);
    formData.append("theme", values.theme);
    formData.append("bgColor", values.bgColor);
    formData.append("wishes", JSON.stringify(values.wishes));
    formData.append("thumbnail", values.thumbnail);
    values.images.forEach((img, i) => {
      formData.append("images", img);
    });

    formData.append("isPurged", false);
    try {
      setLoading(false);
      const res = await INVITATION.UPDATE(formData, id);
      if (res.status === 200) {
        toast.success("Updated Invitation");
        navigate(`/invitation`);
      } else {
        toast.error("Failed to Update Invitation");
        throw new Error("failed to create an topic");
      }
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        await checkAccessTokenValidity();
        setReRunData(values);
        setRefresh(!refresh);
      }
      // console.log("error", error);
    }
  };
  const handleImageChange = (file, setFieldValue) => {
    setData({
      ...data,
      thumbnail: file,
    });
    const fileLoaded = URL.createObjectURL(file);
    setimageView(fileLoaded);
    setFieldValue("thumbnail", file);
  };
  const handleFlowerChange = (file, setFieldValue) => {
    setData({
      ...data,
      flower: file,
    });
    const fileLoaded = URL.createObjectURL(file);
    setFlowerView(fileLoaded);
    setFieldValue("flower", file);
  };

  const showImageList = (files, setFieldValue) => {
    const newImgArray = imageList;
    const newRealArray = data.images;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      newImgArray.push(URL.createObjectURL(file));
      newRealArray.push(file);
    }

    // Combine with existing images
    const updatedImageList = [...imageList, ...newImgArray].slice(0, 6);
    const updatedRealArray = [...data.images, ...newRealArray].slice(0, 6);

    setImageList(updatedImageList);
    setData((prev) => ({ ...prev, images: updatedRealArray }));

    setFieldValue("images", updatedRealArray);
  };
  const getInvitationData = async () => {
    try {
      const res = await INVITATION.GET_BY_ID(id);
      const invitationData = res.data[0];
      if (res.status !== 200) {
        throw new Error("Failed to fetch brand information");
      }
      setData({
        ...data,
        datetime: invitationData.datetime,
        bride: invitationData.bridesName,
        groom: invitationData.groomsName,
        eventLoc: invitationData.location1.title,
        eventLocLink: invitationData.location1.link,
        eventName: invitationData.location1.name,
        receptionLoc: invitationData.location2.title,
        receptionTime: invitationData.location2.time,
        receptionLocLink: invitationData.location2.link,
        receptionName: invitationData.location2.name,
        youtubeLink: invitationData.youTubeLink,
        bgColor: invitationData.bgColor,
        music: invitationData.music,
        // music: musicFile,
        flower: invitationData.flower,
        description: invitationData.description,
        thumbnail: invitationData.thumbnail,
        theme: invitationData.theme,
        images: invitationData.images,
        wishes: invitationData.wishes,
      });
      const imageArray = [];

      invitationData.images.map((itm) => {
        return imageArray.push(`${CONSTANT.UI_URL}images/${itm}`);
      });
      setImageList(imageArray);

      setFlowerView(`${CONSTANT.UI_URL}flower/${invitationData.flower}`);
      setimageView(`${CONSTANT.UI_URL}thumbnail/${invitationData.thumbnail}`);

    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };

  useEffect(() => {
    if (reRunData !== null) handleSubmit(reRunData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  useEffect(() => {
    getInvitationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, change]);

  return (
    <div>
      <Breadcrumbs pageName="Update Digital Invitation" />
      <div className=" rounded-md border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="border-b border-stroke py-4 px-6.5 dark:border-strokedark">
          <h3 className="font-medium text-black dark:text-white">Event Info</h3>
        </div>
        <Formik
          initialValues={data}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {(formik) => (
            <Form>
              <div className="grid grid-cols-1 sm:grid-cols-2 pt-6.5">
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Date & Time <span className="text-meta-1">*</span>
                  </label>
                  <Field
                    type="datetime-local"
                    placeholder="Enter date & time"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="datetime"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="datetime"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Bride <span className="text-meta-1">*</span>
                  </label>
                  <Field
                    placeholder="Enter brides name"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="bride"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="bride"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Groom <span className="text-meta-1">*</span>
                  </label>
                  <Field
                    placeholder="Enter grooms name"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="groom"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="groom"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Event Title <span className="text-meta-1">*</span>
                  </label>
                  <Field
                    placeholder="Enter event title"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="eventName"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="eventName"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Event Location <span className="text-meta-1">*</span>
                  </label>
                  <Field
                    placeholder="Enter location"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="eventLoc"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="eventLoc"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Event location link <span className="text-meta-1">*</span>
                  </label>
                  <Field
                    placeholder="Enter location link"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="eventLocLink"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="eventLocLink"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Reception Title
                  </label>
                  <Field
                    placeholder="Enter reception title"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="receptionName"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="receptionName"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Reception Location
                  </label>
                  <Field
                    placeholder="Enter location"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="receptionLoc"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="receptionLoc"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Reception Time
                  </label>
                  <Field
                    placeholder="Enter reception time"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="receptionTime"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="receptionTime"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Reception location link
                  </label>
                  <Field
                    placeholder="Enter location link"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="receptionLocLink"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="receptionLocLink"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Youtube link
                  </label>
                  <Field
                    placeholder="Enter youtube link"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="youtubeLink"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="youtubeLink"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Background Colour <span className="text-meta-1">*</span>
                  </label>
                  <Field
                    placeholder="Enter colour in hexcode"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="bgColor"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="bgColor"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Description <span className="text-meta-1">*</span>
                  </label>
                  <Field
                    as="textarea"
                    name="description"
                    placeholder="Enter your message here"
                    rows={4}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="description"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Background Music <span className="text-meta-1">*</span>
                  </label>
                  <FormikAudioInput name="music" accept=".mp3,audio/mpeg" />
                </div>
                <div className="p-6.5 pt-0">
                  <div className="mb-4.5 ">
                    <label className="mb-2.5 block text-black dark:text-white">
                      Add Photos
                    </label>

                    <div className="flex items-center justify-center w-full">
                      <label
                        htmlFor="dropzone-file"
                        className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-50 hover:bg-gray dark:border-gray dark:hover:border-gray dark:hover:bg-gray"
                      >
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          <svg
                            className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 16"
                          >
                            <path
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                            />
                          </svg>
                          <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                            <span className="font-semibold">
                              Click to upload photos
                            </span>
                            {/* or drag and drop */}
                          </p>
                          <p className="text-xs text-gray-500 dark:text-gray-400">
                            PNG, JPG or JPEG (MAX. 800x400px)
                          </p>
                        </div>
                        <input
                          id="dropzone-file"
                          type="file"
                          className="hidden"
                          multiple
                          onChange={(e) => {
                            showImageList(e.target.files, formik.setFieldValue);
                          }}
                        />
                      </label>
                    </div>
                  </div>

                  <ErrorMessage
                    name="images"
                    component="a"
                    className="text-danger"
                  />

                  <div className="my-4.5">
                    <div className="grid grid-cols-4 gap-4">
                      {imageList.map((items, index) => (
                        <div
                          key={items}
                          className="w-full group relative cursor-pointer h-25 flex justify-center items-center rounded border-2 border-gray-300 border-dashed "
                        >
                          <img
                            src={items}
                            alt="images"
                            unoptimized
                            width={0}
                            height={0}
                            sizes="100vw"
                            style={{ width: "100%", height: "100%" }}
                            className=" object-contain"
                          />

                          <button
                            type="button"
                            className="transition transform w-full h-full
                            translate-y-8 ease-in-out invisible  
                            absolute group-hover:visible 
                            text-white group-hover:translate-y-0 bg-black flex justify-center items-center opacity-75"
                            onClick={() => {
                              imageList.splice(index, 1);
                              data.images.splice(index, 1);
                              setData({
                                ...data,
                                images: data.images,
                              });
                              setImageList(imageList);
                            }}
                          >
                            <svg
                              className="fill-current"
                              width="30"
                              height="30"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                                fill=""
                              />
                              <path
                                d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                                fill=""
                              />
                              <path
                                d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                                fill=""
                              />
                              <path
                                d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                                fill=""
                              />
                            </svg>
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Thumbnail
                    <span className="text-meta-1">*</span>
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label
                      htmlFor="image-file"
                      className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-50 hover:bg-gray dark:border-gray dark:hover:border-gray dark:hover:bg-gray"
                    >
                      {imageView !== "" ? (
                        <div className="w-full group relative cursor-pointer h-full flex justify-center items-center rounded ">
                          <img
                            src={imageView}
                            alt="images"
                            className="h-full object-contain"
                          />
                          <button
                            type="button"
                            className="transition transform w-full h-full
                                                             translate-y-8 ease-in-out invisible  
                                                             absolute group-hover:visible 
                                                                 text-white group-hover:translate-y-0 bg-black flex justify-center items-center opacity-75 "
                            onClick={() => {
                              setData({
                                ...data,
                                thumbnail: "",
                              });
                              setimageView("");
                            }}
                          >
                            <svg
                              className="fill-current"
                              width="30"
                              height="30"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                                fill=""
                              />
                              <path
                                d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                                fill=""
                              />
                              <path
                                d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                                fill=""
                              />
                              <path
                                d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                                fill=""
                              />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                Click to upload Image
                              </span>
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                              PNG, JPG or JPEG (MAX. 800x400px)
                            </p>
                          </div>
                          <input
                            id="image-file"
                            type="file"
                            className="hidden "
                            onChange={(e) => {
                              handleImageChange(
                                e.target.files[0],
                                formik.setFieldValue
                              );
                            }}
                          />
                        </>
                      )}
                    </label>
                  </div>
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="thumbnail"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Flower
                    <span className="text-meta-1">*</span>
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label
                      htmlFor="image-file1"
                      className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-50 hover:bg-gray dark:border-gray dark:hover:border-gray dark:hover:bg-gray"
                    >
                      {flowerView !== "" ? (
                        <div className="w-full group relative cursor-pointer h-full flex justify-center items-center rounded ">
                          <img
                            src={flowerView}
                            alt="flower"
                            className="h-full object-contain"
                          />
                          <button
                            type="button"
                            className="transition transform w-full h-full
                                                             translate-y-8 ease-in-out invisible  
                                                             absolute group-hover:visible 
                                                                 text-white group-hover:translate-y-0 bg-black flex justify-center items-center opacity-75 "
                            onClick={() => {
                              setData({
                                ...data,
                                flower: "",
                              });
                              setFlowerView("");
                            }}
                          >
                            <svg
                              className="fill-current"
                              width="30"
                              height="30"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                                fill=""
                              />
                              <path
                                d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                                fill=""
                              />
                              <path
                                d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                                fill=""
                              />
                              <path
                                d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                                fill=""
                              />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                Click to upload Image
                              </span>
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                              PNG, JPG or JPEG (MAX. 800x400px)
                            </p>
                          </div>
                          <input
                            id="image-file1"
                            type="file"
                            className="hidden "
                            onChange={(e) => {
                              handleFlowerChange(
                                e.target.files[0],
                                formik.setFieldValue
                              );
                            }}
                          />
                        </>
                      )}
                    </label>
                  </div>
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="flower"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 p-6.5 pt-0">
                {theme.map((itm) => (
                  <button
                    key={itm.id}
                    className={`flex w-[98%] mx-[1%] justify-center rounded border-2 border-success ${
                      itm.title === data.theme
                        ? "bg-success text-gray"
                        : "bg-white text-black"
                    } p-3 font-medium `}
                    onClick={() => {
                      setData({
                        ...data,
                        theme: itm.title,
                      });
                    }}
                    type="button"
                  >
                    {itm.title}
                  </button>
                ))}
              </div>

              <div className="p-6.5 pt-0">
                <button
                  type="submit"
                  className="flex w-full justify-center rounded bg-primary p-3 font-medium text-gray"
                >
                  {loading ? (
                    <div className="flex h-auto items-center justify-center ">
                      <div className="h-6 w-6 animate-spin rounded-full border-4 border-solid border-white border-t-transparent"></div>
                    </div>
                  ) : (
                    "Update Invitation"
                  )}
                </button>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 px-6.5 border-t-2 py-10">
                <button
                  className={`border-2 border-black rounded-md flex w-[98%] mx-[1%] justify-center rounded bg-white p-3 font-medium text-black`}
                  onClick={() => {
                    setViewWish(!viewWish);
                  }}
                  type="button"
                >
                  {viewWish ? "Hide" : "Show"} Wishes {viewWish ? "↑" : "↓"}
                </button>
              </div>
              {viewWish && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 px-6.5 py-5">
                  {data.wishes.map((itm, index) => (
                    <div
                      key={itm.wish}
                      className={`${
                        itm.isApproved ? "bg-success" : "bg-danger"
                      } rounded-md flex flex-col justify-center items-center p-5`}
                    >
                      <p className="text-black text-lg font-semibold">
                        {itm.wish}
                      </p>
                      <p className="text-black text-base">♡ {itm.from}</p>
                      {!itm.isApproved ? (
                        <button
                          type="button"
                          className="bg-white px-2 py-1 rounded-md text-black mt-2"
                          onClick={() => {
                            approveWish(index);
                          }}
                        >
                          APPROVE
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="bg-white px-2 py-1 rounded-md text-black mt-2"
                          onClick={() => {
                            hideWish(index);
                          }}
                        >
                          HIDE
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
